var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 345.88 221.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dcb998;}.cls-2{fill:#c5a07d;}.cls-3{fill:#ececec;}.cls-4{fill:#c8cad1;}.cls-5{fill:#ded6ce;}.cls-10,.cls-6,.cls-7,.cls-8{fill:none;stroke-miterlimit:10;}.cls-6{stroke:#a3866a;}.cls-7{stroke:#f2dac5;}.cls-8{stroke:#fdebdd;}.cls-9{fill:#f2dac5;}.cls-10{stroke:#dcb998;}.cls-11{fill:#fff;}.cls-12{fill:#d9e6ed;}.cls-13{fill:#acc6d1;}.cls-14{opacity:0.4;}.cls-15{fill:#9aa4ae;}.cls-16{fill:#85929c;}.cls-17{fill:#b8bcc1;}.cls-18{fill:#7c878c;}.cls-19{fill:#8d9aa0;}.cls-20{fill:#2a3335;}.cls-21{fill:#343f42;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Table_01a",
    "data-name": "Table_01a",
    viewBox: "0 0 336 213.3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("image", {
    width: 336,
    height: 181,
    transform: "translate(0 32.3)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "36.94 56.18 36.94 92.18 126.72 144.01 126.72 108.01 36.94 56.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "299.61 51.83 299.61 87.73 126.72 144.01 126.72 108.01 299.61 51.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "36.94 56.18 126.72 108.01 299.61 51.83 209.84 0 36.94 56.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "60.22 105.61 60.22 123.61 53.57 125.78 53.57 101.78 60.22 105.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "46.92 97.94 46.92 121.94 53.57 125.78 53.57 101.78 46.92 97.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "60.22 123.61 60.22 132.62 53.57 134.78 53.57 125.78 60.22 123.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "46.92 121.94 46.92 130.94 53.57 134.78 53.57 125.78 46.92 121.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "133.37 141.85 133.37 165.85 126.72 168.01 126.72 144.01 133.37 141.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "120.07 140.17 120.07 164.17 126.72 168.01 126.72 144.01 120.07 140.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "133.37 165.85 133.37 174.85 126.72 177.01 126.72 168.01 133.37 165.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "120.07 164.17 120.07 173.17 126.72 177.01 126.72 168.01 120.07 164.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "286.74 91.72 286.74 115.72 280.09 117.88 280.09 93.88 286.74 91.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "273.44 96.04 273.44 114.04 280.09 117.88 280.09 93.88 273.44 96.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "286.74 115.72 286.74 124.72 280.09 126.88 280.09 117.88 286.74 115.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "273.44 114.04 273.44 123.04 280.09 126.88 280.09 117.88 273.44 114.04"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "BoxOpen_01a",
    "data-name": "BoxOpen_01a",
    viewBox: "0 0 119.7 94.43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.3 16.85 53.2 39.88 59.85 37.72 59.85 1.72 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.75 24.76 59.85 37.72 59.85 1.72 99.75 24.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.21,32.7a1.6,1.6,0,0,0-.91-1.2l0-1.94h0c0-.52-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.52-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7,7,0,0,0-5.14.35,1.11,1.11,0,0,0-.64.93h0l0,1.88-.14.08a1.38,1.38,0,0,0-.8,1.16h0l0,1.67-.13-.07V16.9h0c0-.52-.59-1-1.63-1.34a7,7,0,0,0-5.14.4c-.44.29-.65.61-.63.94h0v1.88l-.14.07A1.41,1.41,0,0,0,47.88,20h0v1.6l-.09-.05V19.64h0c0-.52-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.88a.91.91,0,0,0-.14.07,1.4,1.4,0,0,0-.78,1.18h0v1.59l-.09-.05V22.37h0c0-.51-.59-1-1.63-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.89l-.14.07A1.43,1.43,0,0,0,31,25.5h0v1.6l-.09-.05V25.11h0c0-.51-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.11,1.11,0,0,0-.62.94h0V27l-.13.08a1.36,1.36,0,0,0-.79,1.17h0v1.6l-.09-.05V27.85h0c0-.52-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.88a.91.91,0,0,1-.14.07A1.4,1.4,0,0,0,14.19,31h0V43.12h0c0,.65.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a10,10,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.67,2.12.65,5,.43,6.43-.5A1.38,1.38,0,0,0,50,58.48h0v-1.6a4.79,4.79,0,0,0,1.22.54,8.81,8.81,0,0,0,6.42-.5,1.4,1.4,0,0,0,.78-1.18h0v-1.6a4.71,4.71,0,0,0,1.21.54,8.8,8.8,0,0,0,6.42-.5A1.39,1.39,0,0,0,66.89,53h0V51.41a5.28,5.28,0,0,0,1.21.53c2.13.65,5,.43,6.43-.5a1.39,1.39,0,0,0,.78-1.17h0v-1.6a4.91,4.91,0,0,0,1.21.54c2.12.64,5,.42,6.42-.51a1.38,1.38,0,0,0,.79-1.17h0V45.94a4.79,4.79,0,0,0,1.11.5c2.12.67,5,.48,6.43-.43a1.38,1.38,0,0,0,.8-1.17h0l.13-12.14Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 61.02,
    cy: 14.35,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(45.35 75.04) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 52.51,
    cy: 17.09,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(34.86 69.41) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 44.09,
    cy: 19.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(23.79 63.69) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 35.66,
    cy: 22.56,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(12.72 57.98) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 27.24,
    cy: 25.3,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(1.65 52.26) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 18.81,
    cy: 28.03,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-9.42 46.54) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 67.67,
    cy: 18.19,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(48.02 85.45) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 59.16,
    cy: 20.93,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(37.6 79.86) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 50.74,
    cy: 23.66,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(26.53 74.14) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 42.31,
    cy: 26.4,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(15.46 68.42) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 33.89,
    cy: 29.14,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(4.39 62.71) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 25.46,
    cy: 31.87,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-6.68 56.99) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 74.32,
    cy: 22.03,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(50.69 95.85) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 65.81,
    cy: 24.76,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(40.34 90.3) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 57.39,
    cy: 27.5,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(29.27 84.59) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 48.96,
    cy: 30.24,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(18.19 78.87) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 40.54,
    cy: 32.98,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(7.12 73.15) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 32.11,
    cy: 35.71,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-3.95 67.44) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 80.97,
    cy: 25.87,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(53.35 106.26) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 72.46,
    cy: 28.6,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(43.07 100.75) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 64.04,
    cy: 31.34,
    rx: 1.31,
    ry: 2.96,
    transform: "matrix(0.01, -1, 1, 0.01, 32, 95.03)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 55.61,
    cy: 34.08,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(20.93 89.32) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 47.19,
    cy: 36.82,
    rx: 1.31,
    ry: 2.96,
    transform: "matrix(0.01, -1, 1, 0.01, 9.86, 83.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 38.76,
    cy: 39.55,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-1.21 77.89) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 87.62,
    cy: 29.71,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(56.02 116.66) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 79.11,
    cy: 32.44,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(45.81 111.2) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 70.69,
    cy: 35.18,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(34.74 105.48) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 62.26,
    cy: 37.92,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(23.67 99.77) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 53.84,
    cy: 40.65,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(12.6 94.05) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 45.41,
    cy: 43.39,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(1.53 88.33) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.75 24.76 53.2 39.88 53.2 93.88 99.75 78.76 99.75 24.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.3 16.85 53.2 39.88 53.2 93.88 13.3 70.85 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "33.25 34.36 46.55 42.04 46.55 54.04 33.25 46.36 33.25 34.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 53.2,
    y1: 39.88,
    x2: 53.2,
    y2: 93.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "99.75 78.76 53.2 93.88 13.3 70.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 99.75,
    y1: 24.76,
    x2: 99.75,
    y2: 78.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 59.85,
    y1: 1.72,
    x2: 99.75,
    y2: 24.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "53.2 39.88 99.75 24.76 113.05 44.44 66.5 59.56 53.2 39.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "13.3 16.85 53.2 39.88 39.9 56.2 0 33.17 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "79.8 7.24 59.85 1.72 99.75 24.76 119.7 30.27 79.8 7.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "46.48 0 59.85 1.72 13.3 16.85 0 15.17 46.48 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Box_01a",
    "data-name": "Box_01a",
    viewBox: "0 0 87.2 93.25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.25 15.67 40.15 38.7 40.15 92.7 0.25 69.67 0.25 15.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.7 23.58 40.15 38.7 40.15 92.7 86.7 77.58 86.7 23.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "0.25 15.67 40.15 38.7 86.7 23.58 46.8 0.54 0.25 15.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 23.49,
    y1: 8.12,
    x2: 63.39,
    y2: 31.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "20.2 33.19 33.5 40.87 33.5 52.87 20.2 45.19 20.2 33.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 40.15,
    y1: 38.7,
    x2: 40.15,
    y2: 92.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "86.7 77.58 40.15 92.7 0.25 69.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 86.7,
    y1: 23.58,
    x2: 86.7,
    y2: 77.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "0.25 15.67 46.8 0.54 86.7 23.58"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jar_01b",
    "data-name": "Jar_01b",
    viewBox: "0 0 9.26 18.96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M9.26,4.77h0c0-.65-.75-1.28-2-1.68a8.8,8.8,0,0,0-6.42.5A1.41,1.41,0,0,0,0,4.77H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M8.33,1.64h0c0-.52-.59-1-1.63-1.34A7,7,0,0,0,1.56.7a1.08,1.08,0,0,0-.63.94h0v2h0c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 4.63,
    cy: 1.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(2.76 6.43) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M9.26,4.77a.24.24,0,0,0,0-.09,1.32,1.32,0,0,1-.76,1.26c-1.42.93-4.3,1.15-6.42.5C.74,6,0,5.41,0,4.76H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0V4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2.05,6.44c-1.3-.4-2-1-2-1.67H0V16.91H0c0,.65.75,1.28,2.05,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M8.31,1.56A1.37,1.37,0,0,1,7.43,3a7.21,7.21,0,0,1-5.21.19C1.15,2.8.9,2.1.94,1.55c0,0,0,.06,0,.09h0v2c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0v-2h0S8.31,1.59,8.31,1.56Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("use", {
    width: 336,
    height: 213.3,
    xlinkHref: "#Table_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 119.7,
    height: 94.43,
    transform: "translate(226.18 103.77)",
    xlinkHref: "#BoxOpen_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 87.2,
    height: 93.25,
    transform: "translate(158.68 127.87)",
    xlinkHref: "#Box_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(198.1 15.37)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(226.32 13.9)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(92.64 51.81)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(120.57 67.77)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(208.29 35.99)",
    xlinkHref: "#Jar_01b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.808928d53f015261b65d049d071c7964.svg";
export { ForwardRef as ReactComponent };